/* @flow */
import { Base64 as base64 } from 'js-base64';

// NOTE: btoa and atob expects binaryString and causes issue if used
// on Unicode strings see https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa

export default class Base64 {
    static encode(value: string): string {
        return base64.encode(value);
    }

    static decode(value: string): string {
        return base64.decode(value);
    }
}
